import Model, { attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type StringTransform from 'teacher-ui-client/transforms/string'
import type NumberTransform from 'teacher-ui-client/transforms/number'

export default class BookLibraryReadingScale extends Model {
  /* Actually an accent or program version */
  @attr<StringTransform>('string') declare locale: string

  @attr<NumberTransform>('number') declare blakeReadingLevel: number

  // eslint-disable-next-line customPlugin/prefer-american-color
  @attr<StringTransform>('string') declare bookColour: string

  @attr<StringTransform>('string') declare dra: string

  @attr<StringTransform>('string') declare fpAz: string

  @attr<NumberTransform>('number') declare rrLevel: number

  @attr<StringTransform>('string') declare yearLevel: string

  // A lexile range string like 20L-30L
  @attr<StringTransform>('string') declare lexileRange: string

  // A lexile range lower string like 20L
  @attr<StringTransform>('string') declare lexileRangeLower: string

  // A lexile range upper string like 30L
  @attr<StringTransform>('string') declare lexileRangeUpper: string;

  [Type] = 'book-library/reading-scale' as const
}
